<label class="db-fc-switch db-fc-switch__{{size}} db-fc-switch_color_{{color}}" [ngClass]="{'db-fc-switch_inverted': inverted, 'db-fc-switch_disabled': formControl.disabled}">
  <input type="checkbox" [formControl]="formControl">
  <span class="db-fc-switch__bg"></span>
  <span class="db-fc-switch__head"></span>
</label>
